import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { DoubleBarLabelPlacementOptions } from "@/components/DataInfoCard/types";

const {
  colors: { ui },
} = constants;

const coreBlue25 = ui.core[25];
const coreBlue500 = ui.core[500];
const darkBlue700 = ui.core[700];

export const loadingRootCss: CSSObject = {
  borderRadius: "0px 8px 0px 0px",
  paddingTop: "1rem",
};

export const widgetContainerCss = (labelPlacement: string) => {
  return {
    display: "grid",
    gridTemplateAreas: `
      "topLeft topRight"
      "bottomLeft bottomRight"
    `,
    gridTemplateRows: "1fr auto",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "0px 10px",
    borderRadius: "16px",
    background: coreBlue25,
    padding:
      labelPlacement === DoubleBarLabelPlacementOptions.bottom
        ? "16px 16px 32px"
        : "12px",
    color: ui.neutral[700],
    height: "100%",
  };
};

export const topLeftGridCss: CSSObject = {
  gridArea: "topLeft",
};

export const topRightGridCss: CSSObject = {
  gridArea: "topRight",
};

export const labelOneCss: CSSObject = {
  gridArea: "bottomLeft",
};

export const labelTwoCss: CSSObject = {
  gridArea: "bottomRight",
};

export const topCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
};

export const labelCss: CSSObject = {
  fontSize: ".875rem",
};

export const valueCss: CSSObject = {
  flex: 1,
  alignContent: "flex-end",
  color: darkBlue700,
  fontWeight: "bold",
  marginBottom: ".5rem",
  fontSize: "1.25rem",
};

export const barOneCss = (heightOfBar: number) => {
  return {
    backgroundColor: coreBlue500,
    height: heightOfBar === 0 ? "4px" : `${heightOfBar}%`,
  };
};

export const barTwoCss = (heightOfBar: number) => {
  return {
    backgroundColor: darkBlue700,
    height: `${heightOfBar}%`,
  };
};

export const barCss: CSSObject = {
  borderRadius: "0px 8px 0px 0px",
  minHeight: "4px",
};
